import { Component } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaPopover from "../../../../ui-kit/kuika-popover/kuika-popover";
import KuikaSmallMediumText from "../../../../ui-kit/typography/SmallMediumText/SmallMediumText";

interface IAddColorPopoverProps {
  onAddColor: () => void;
  newColorName: string;
  onNameChange: (name: string) => void;
  currentColor: string;
  children: React.ReactNode;
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
}

class AddColorPopover extends Component<IAddColorPopoverProps> {
  handleAddColor = () => {
    this.props.onAddColor();
    this.props.onVisibleChange?.(false);
  };

  render() {
    const { newColorName, onNameChange, currentColor, children, visible, onVisibleChange } = this.props;

    return (
      <KuikaPopover
        visible={visible}
        onVisibleChange={onVisibleChange}
        content={
          <div className="add-color-area">
            <div className="add-color-area__field">
              <KuikaSmallMediumText>Name</KuikaSmallMediumText>
              <KuikaInput
                value={newColorName}
                onChange={(e) => onNameChange(e.target.value)}
                onPressEnter={this.handleAddColor}
                autoFocus
                size="sm"
              />
            </div>
            <div className="add-color-area__field">
              <KuikaSmallMediumText>Color</KuikaSmallMediumText>
              <KuikaInput size="sm" value={currentColor} rightUnit="HEX" readOnly />
            </div>
            <KuikaButton type="primary" size="sm" onClick={this.handleAddColor} uppercase>
              <KuikaSmallMediumText>Add Color</KuikaSmallMediumText>
            </KuikaButton>
          </div>
        }
        position="bottom"
      >
        {children}
      </KuikaPopover>
    );
  }
}

export default AddColorPopover;
